import { render, staticRenderFns } from "./layout.pug?vue&type=template&id=2f8a7fe4&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./layout.scss?vue&type=style&index=0&id=2f8a7fe4&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8a7fe4",
  null
  
)

export default component.exports